export enum HideColumnsTestIds {
  HIDE_COLUMNS_BUTTON = 'hide-columns-button',
  COLUMN_ITEM_PREFIX = 'hide-columns-item-',
  SAVE_BUTTON = 'hide-columns-save-button',
  RESTORE_BUTTON = 'hide-columns-restore-button',
  CLOSE_BUTTON = 'hide-columns-close-button',
}
